import React from "react";
import { Button, Icon } from "aible";

import Select from "react-select";
import { LineInput } from "components/Inputs/LineInput";
import Tooltip from "components/Inputs/Tooltip";

import { parseRoleType } from "containers/Folders/reducer";
import { ROLE_VALUES } from "containers/App/reducer";

import styles from "./style.module.css";
import { isEnabled } from "utils/featureFlags";
import LabeledToggle from "../Inputs/Toggle/Toggle";
import WarningIcon from "images/warning.svg";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const DEFAULT_FORM = {
  name: "",
  description: "",
  collaborators: undefined,
  defaultRoleType: undefined,
  defaultRoleConfirmation: undefined
};
export default class FolderCreate extends React.PureComponent {
  state = this.props.isEdit
    ? {
        name: this.props.folderName,
        description: this.props.folderDescription,
        showCollaborators: true
      }
    : {
        ...DEFAULT_FORM,
        usersAccessToggle: false,
        showCollaborators: false
      };

  resetForm() {
    const { isEdit, folderName, folderDescription } = this.props;
    return this.setState({
      ...DEFAULT_FORM,
      usersAccessToggle: false,
      showCollaborators: false
    });
  }

  handleClose(e) {
    const { handleHide } = this.props;
    this.resetForm();
    return handleHide(e);
  }

  handleDeleteCollaborator(user, clear, userData) {
    const { isEdit, deleteUserRole, isManagePermissions } = this.props;
    const { collaborators, showCollaborators } = this.state;

    if (isEdit || isManagePermissions) {
      return deleteUserRole && deleteUserRole(userData && userData.id);
    }

    const retCollaborators = clear
      ? undefined
      : collaborators && collaborators.filter((elem) => user && elem.user && user.value !== elem.user.value);
    return this.setState({
      collaborators: retCollaborators && retCollaborators.length ? retCollaborators : undefined,
      showCollaborators: clear ? false : showCollaborators
    });
  }

  handleEditCollaborator(user, role, userData) {
    const { isEdit, patchUserRole, isManagePermissions } = this.props;
    const { collaborators } = this.state;

    if (isEdit || isManagePermissions) {
      return patchUserRole && patchUserRole(userData && userData.id, role && role.value);
    }

    const retCollaborators = collaborators
      ? collaborators.map((c) => {
          if (c.user && user && c.user.value === user.value) {
            return { user: user, role: role };
          } else {
            return c;
          }
        })
      : [{ user: user, role: role }];
    return this.setState({
      collaborators: retCollaborators && retCollaborators.length ? retCollaborators : undefined
    });
  }

  handleAddCollaborator(user, role) {
    const { isEdit, addUserRole, isManagePermissions } = this.props;
    const { collaborators } = this.state;

    if (isEdit || isManagePermissions) {
      addUserRole && addUserRole(user, role && role.value);
    }

    const retCollaborators = collaborators
      ? [...collaborators, { user: user, role: role }]
      : [{ user: user, role: role }];
    return this.setState({ collaborators: retCollaborators });
  }

  handleCreate(e) {
    const { createFolder, isEdit, editFolder } = this.props;
    const { name, description, collaborators, defaultRoleType } = this.state;

    if (isEdit) {
      let nameEdit = undefined;
      let descriptionEdit = undefined;
      if (name !== this.props.name) {
        nameEdit = name;
      }
      if (description !== this.props.description) {
        descriptionEdit = description;
      }
      if (nameEdit !== undefined || descriptionEdit !== undefined) {
        editFolder(nameEdit, descriptionEdit);
      }
      return this.handleClose(e);
    }

    const retCollaborators =
      collaborators &&
      collaborators.map((c) => {
        const userId = c.user && c.user.value;
        const role = c.role && c.role.value;
        return { role_user: userId, role_type: role };
      });
    const defaultRoleTypeValue = defaultRoleType?.value;
    createFolder && createFolder(name, description, retCollaborators, defaultRoleTypeValue);
    return this.handleClose(e);
  }

  handleDelete() {
    const { isEdit, deleteFolder } = this.props;
    if (isEdit) {
      deleteFolder && deleteFolder();
      return this.handleClose();
    }
  }

  handleLineEdit(val, stateProp) {
    const { editFolder, isEdit } = this.props;

    if (val && stateProp === "name") {
      // if (isEdit) {
      //   editFolder(val.trim(), undefined);
      // }
      return this.setState({ name: val.trim() });
    } else if (stateProp === "description") {
      // if (isEdit) {
      //   editFolder(undefined, val);
      // }
      return this.setState({ description: val });
    }
  }

  handleToggleAllUsers() {
    this.setState((prevState) => ({
      ...prevState,
      usersAccessToggle: !prevState.usersAccessToggle,
      defaultRoleType: !prevState.usersAccessToggle ? ROLE_VALUES["VIEWER"] : undefined
    }));
  }

  render() {
    const {
      handleClose,
      showModal,
      users,
      roles,
      userName,
      isEdit,
      folderRoles,
      folderName,
      folderDescription,
      userRole,
      id,
      defaultFolderId,
      userId,
      canDelete,
      canEdit,
      canManagePermissions,
      setDefaultFolder,
      isManagePermissions,
      allowSelectUser
    } = this.props;

    const {
      name,
      description,
      collaborators,
      showCollaborators,
      defaultRoleType,
      usersAccessToggle,
      defaultRoleConfirmation
    } = this.state;

    const retCollaborators =
      isEdit || isManagePermissions
        ? folderRoles &&
          folderRoles.map((role) => {
            return {
              user: {
                label: role.role_user && role.role_user.fullname,
                value: role.role_user && role.role_user.id
              },
              role: { label: parseRoleType(role.role_type), value: role.role_type },
              data: role
            };
          })
        : collaborators;

    const isConfirmed = defaultRoleConfirmation === "YES";
    const canEditFolder = isEdit && canEdit && name?.length >= 3;
    const canCreateFolder =
      !isEdit &&
      name?.length >= 3 &&
      (!usersAccessToggle || (usersAccessToggle && defaultRoleConfirmation && isConfirmed));

    return (
      <Dialog open={showModal} onOpenChange={(e) => this.handleClose(e)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {isEdit ? "Edit Folder" : isManagePermissions ? "Manage Users" : "Create New Folder"}
            </DialogTitle>
          </DialogHeader>
          <div className={styles.folderCreateModalItem} style={{ marginBottom: "6px" }}>
            <div className={styles.folderCreateModalLabel}>{"Folder Name"}</div>
            {isManagePermissions || (isEdit && !canEdit) ? (
              folderName
            ) : (
              <React.Fragment>
                <LineInput
                  isBox
                  placeholder={"Enter Folder Name"}
                  value={isEdit ? name || folderName : name}
                  className={styles.folderCreateModalInput}
                  onChange={(val) => this.handleLineEdit(val, "name")}
                  updateInstant={true}
                />
              </React.Fragment>
            )}
          </div>
          {!isManagePermissions && (
            <React.Fragment>
              <div className={styles.folderCreateModalItem}>
                <div className={styles.folderCreateModalLabel}>
                  {"Folder Description "}
                  <span className={styles.lightText}>{!isEdit || canManagePermissions ? "(Optional)" : ""}</span>
                </div>
                {isEdit && !canEdit ? (
                  folderDescription
                ) : (
                  <LineInput
                    isBox
                    defaultValue={isEdit ? description || folderDescription : description || ""}
                    className={styles.folderCreateModalInput}
                    onChange={(val) => this.handleLineEdit(val, "description")}
                  />
                )}
              </div>
              {isEdit && canDelete && (
                <div className={styles.folderCreateModalItem}>
                  <div>
                    <Tooltip
                      trigger={userRole !== ROLE_VALUES?.OWNER?.value ? ["hover"] : []}
                      overlay={
                        <div style={{ maxWidth: "300px" }}>
                          <div>
                            {`You do not have permission to delete this folder. Only a user with the ${ROLE_VALUES?.OWNER?.value} role may delete a folder.`}
                          </div>
                          <div style={{ marginTop: "10px" }}>{`Your role is ${userRole}`}</div>
                        </div>
                      }
                    >
                      <Button
                        type="secondary"
                        style={{
                          background: "#C03E5A",
                          color: "#FFFFFF"
                        }}
                        onClick={(e) => this.handleDelete()}
                        disabled={userRole !== ROLE_VALUES?.OWNER?.value}
                      >
                        <Icon type={userRole !== ROLE_VALUES?.OWNER?.value ? "trashGrey" : "trashWhite"} size={20} />
                        <span style={{ marginLeft: "8px" }}>{"Delete Folder"}</span>
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
          {!isEdit && (
            <div
              className={styles.folderCreateModalItem}
              style={{ marginBottom: isManagePermissions || (!isEdit && showCollaborators) ? "0px" : undefined }}
            >
              <div style={{ fontWeight: "bold" }}>
                {!isEdit && !isManagePermissions ? "Would you like to add users to the folder?" : ""}
              </div>
              {!showCollaborators && !isEdit && !isManagePermissions ? (
                <div className={styles.addUsersWrapper}>
                  <div className={usersAccessToggle ? styles.addUsersDisabled : undefined}>
                    <div style={{ fontWeight: "bold" }}>Add specific users</div>
                    You can also do this after the folder is created
                  </div>
                  <Button
                    className={styles.folderCreateCollaboratorsButton}
                    type="secondary"
                    onClick={() => this.setState({ showCollaborators: true })}
                    disabled={usersAccessToggle}
                  >
                    {usersAccessToggle ? "All users will be added" : "Select users to add"}
                  </Button>
                </div>
              ) : (
                <Users
                  handleClose={() => this.setState({ showCollaborators: false })}
                  users={users}
                  userId={userId}
                  userName={userName}
                  roles={roles}
                  collaborators={retCollaborators}
                  canManagePermissions={canManagePermissions}
                  handleAddCollaborator={(user, role) => this.handleAddCollaborator(user, role)}
                  handleDeleteCollaborator={(user, clear, data) => this.handleDeleteCollaborator(user, clear, data)}
                  handleEditCollaborator={(user, role, data) => this.handleEditCollaborator(user, role, data)}
                  isEdit={isEdit || isManagePermissions}
                  allowSelectUser={allowSelectUser}
                />
              )}
            </div>
          )}
          {!isEdit && !isManagePermissions && isEnabled("folder-creation-default-roles") && (
            <div style={{ marginBottom: "10px" }}>
              <div style={{ fontWeight: "bold" }}>Allow all users access</div>
              <div>Current and future members in your organization will be able to see this folder</div>
              <div
                style={{
                  display: "flex",
                  margin: "10px 0px 12px",
                  padding: "3px 0px",
                  width: "100%",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px"
                }}
              >
                <LabeledToggle
                  style={{ display: "block" }}
                  checked={usersAccessToggle}
                  onChange={() => {
                    this.handleToggleAllUsers();
                  }}
                  isAibleColors
                />
                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                  <span>Grant all users access</span>
                </div>
              </div>
              {usersAccessToggle && (
                <React.Fragment>
                  <div style={{ maxWidth: "300px", marginBottom: "10px" }}>
                    <div style={{ marginBottom: "5px" }}>Default role for all users</div>
                    <Select
                      placeholder={"Select default access for all users"}
                      options={roles}
                      value={defaultRoleType}
                      onChange={(v) => this.setState({ defaultRoleType: v })}
                    />
                  </div>
                  <div className={styles.defaultRolesWarningWrapper}>
                    <div className={styles.defaultRolesWarningTitle}>
                      <div className={styles.defaultRolesWarningIconWrapper}>
                        <img src={WarningIcon} />
                      </div>
                      <div className={styles.defaultRolesWarningTitleText}>
                        Caution, this action cannot be reversed for this folder
                      </div>
                    </div>
                    <div className={styles.defaultRolesWarningText}>
                      <span>
                        {`This will grant All Users Access To All Projects and Data that are added to this folder if you enable this.

                        Please confirm you want to proceed by typing `}
                        <span style={{ fontWeight: "bold" }}>YES</span>
                        {` in the field below`}
                      </span>
                    </div>
                    <LineInput
                      value={defaultRoleConfirmation}
                      inputClassName={styles.defaultRoleConfirmationInput}
                      onChange={(val) => this.setState({ defaultRoleConfirmation: val })}
                      updateInstant
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          )}
          <DialogFooter>
            <Button
              type="secondary"
              onClick={(e) => this.handleClose(e)}
              style={isManagePermissions ? { marginLeft: "auto" } : undefined}
            >
              {isManagePermissions ? "Close" : "Cancel"}
            </Button>
            {!isManagePermissions && (
              <Button
                type={"primary"}
                style={{ marginLeft: "auto" }}
                disabled={!(canCreateFolder || canEditFolder)}
                onClick={(e) => this.handleCreate(e)}
              >
                {isEdit ? "Apply Updates" : "Create Folder"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}

class Users extends React.Component {
  state = {
    user: null,
    role: null
  };
  render() {
    const {
      users,
      roles,
      handleClose,
      handleAddCollaborator,
      handleDeleteCollaborator,
      handleEditCollaborator,
      userName,
      collaborators,
      userId,
      canManagePermissions,
      isEdit
    } = this.props;
    const { user, role } = this.state;

    const allowSelectUser = this.props.allowSelectUser ?? !isEnabled("chat-aible-consumer");

    return (
      <div className={styles.userListWrapper}>
        {!isEdit || canManagePermissions ? (
          <div className={styles.userInputWrapper} style={{ marginBottom: "20px", minHeight: "60px" }}>
            <div className={styles.userName} style={{ overflow: "visible" }}>
              {allowSelectUser ? (
                <Select
                  placeholder={"Select User to Add"}
                  isSearchable
                  isClearable
                  components={{
                    Option: CustomOption,
                    SingleValue: CustomValue
                  }}
                  option
                  options={
                    users
                      ? users
                          .filter(
                            (u) =>
                              (u.fullname === undefined || userName === undefined || u.fullname !== userName) &&
                              (!collaborators || !collaborators.find((elem) => elem.user && elem.user.value === u.id))
                          )
                          .map((u) => ({
                            label: u.fullname + " " + u.email,
                            fullname: u.fullname,
                            email: u.email,
                            value: u.id,
                            id: u.id
                          }))
                      : []
                  }
                  value={user}
                  onChange={(v) => this.setState({ user: v })}
                />
              ) : (
                <LineInput
                  isBox
                  placeholder={"Enter User Email"}
                  value={user?.email}
                  className={styles.folderCreateModalInput}
                  onChange={(val) => this.setState({ user: { email: val } })}
                  inputStyle={{ width: "100%" }}
                />
              )}
            </div>
            <div className={styles.userRoleSelect}>
              <Select
                placeholder={"Select Role"}
                options={roles}
                value={role}
                onChange={(v) => this.setState({ role: v })}
              />
            </div>
            <div className={styles.userInviteButtonWrapper}>
              <Button
                className={styles.userInviteButton}
                type="secondary"
                onClick={(e) => {
                  handleAddCollaborator && handleAddCollaborator(user, role);
                  this.setState({
                    role: null,
                    user: null
                  });
                }}
                disabled={!role || !user}
              >
                {"Add User"}
              </Button>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className={styles.userList + " " + (!isEdit ? styles.hasOtherFields : "")}>
          {collaborators
            ? collaborators.map((c, i) => {
                const userData = users.find((u) => u?.id === c?.user?.value);
                return (
                  <div className={styles.userInputWrapper} key={"collaborator-" + i}>
                    <div className={styles.userName} title={c.user && c.user.label}>
                      <div>{c.user?.label ? c.user.label : ""}</div>
                      <div className={styles.userEmailText}>{userData?.email ? userData.email : ""}</div>
                    </div>
                    <div className={styles.userRoleSelect}>
                      {isEdit && ((c.user && c.user.value === userId) || !canManagePermissions) ? (
                        c.role && c.role.label
                      ) : (
                        <Select
                          placeholder={"Select Role"}
                          options={roles}
                          value={c.role}
                          onChange={(v) => handleEditCollaborator && handleEditCollaborator(c.user, v, c.data)}
                        />
                      )}
                    </div>
                    <div className={styles.userInviteButtonWrapper}>
                      {isEdit && ((c.user && c.user.value === userId) || !canManagePermissions) ? (
                        ""
                      ) : (
                        <Button
                          className={styles.userInviteButton}
                          onClick={(e) =>
                            handleDeleteCollaborator && handleDeleteCollaborator(c.user, undefined, c.data)
                          }
                          type={"secondary"}
                        >
                          {"Delete"}
                        </Button>
                      )}
                    </div>
                  </div>
                );
              })
            : ""}
        </div>
        <div>
          {/* <Button
          className={styles.folderCreateCollaboratorsButton}
          type="secondary"
          onClick={e => {
            handleDeleteCollaborator && handleDeleteCollaborator(undefined, true)
            this.setState({
              role: undefined,
              user: undefined
            })
          }}
        >
          {"Remove Collaborators"}
        </Button> */}
        </div>
      </div>
    );
  }
}

class CustomOption extends React.PureComponent {
  render() {
    const { value, label, innerProps, data, isCustomValue } = this.props;

    const fullname = data?.fullname;
    const email = data?.email;

    return (
      <div className={styles.userSelectOption + " " + (isCustomValue ? styles.isValue : "")} {...innerProps}>
        <Tooltip
          trigger={["hover"]}
          overlay={
            <div>
              <div className={styles.userSelectOptionLabel}>{fullname}</div>
              <div className={styles.userSelectOptionLabel + " " + styles.small}>{email}</div>
            </div>
          }
        >
          <div style={{ maxWidth: "100%" }}>
            <div className={styles.userSelectOptionLabel}>{fullname}</div>
            <div className={styles.userSelectOptionLabel + " " + styles.small}>{email}</div>
          </div>
        </Tooltip>
      </div>
    );
  }
}

class CustomValue extends React.PureComponent {
  render() {
    return <CustomOption {...this.props} isCustomValue />;
  }
}
